module.exports = __webpack_public_path__ + "static/retail-content-image-2@2x-b7900bb60d22ac83ab5481f3eebdb766.jpg";